import axios from "axios";

export const initializeUser = async (userInitializationData, token) => {
    try {
        const response = await axios.post('/api/users/initialize/', token ? {
            headers: { Authorization: `Bearer ${token}` },
        } : undefined);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const fetchUsers = async () => {
    try {
        const response = await axios.get(`/api/users/`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const fetchCurrentUser = async () => {
    try {
        const response = await axios.get(`/api/users/me`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}
export const fetchUserByUsername = async (username) => {
    try {
        const response = await axios.get(`/api/users/${username}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const createUser = async (userData) => {
    try {
        const response = await axios.post(`/api/users/`, userData);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const updateUser = async (userData) => {
    try {
        const response = await axios.put(`/api/users/`, userData);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const deleteUser = async (userId) => {
    try {
        const response = await axios.delete(`/api/users/${userId}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}   